import { getHeadImage } from 'common/js/getHeadImage'

class User {
  constructor ({userid, sex, name, headimage, studentid, role, roleId, loginName, avatar, token, userID, appVersion}) {
    this.userid = userid || userID
    this.sex = sex // 性别
    this.name = name // 姓名
    this.headimage = headimage || avatar // 头像
    this.studentid = studentid // 学号
    this.role = role || roleId
    this.loginName = loginName
    this.token = token
    // 输出的头像
    this.headIcon = getHeadImage(headimage, sex, role)
    this.appVersion = appVersion
  }
}

class UAccoutService {
  constructor () {
    this.user = {}
  }

  setAccount (option) {
    this.user = new User(option)
  }

  getAccount () {
    return this.user
  }

  // 获取token
  getToken () {
    if (this.user && this.user.token) {
      return this.user.token
    }
    return null
  }
}

export default new UAccoutService()



// WEBPACK FOOTER //
// ./src/common/js/UAccoutService.js